require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coos-county-downward-departure-specialized-caseload.json") })
        }
      }, "path---coos-county-downward-departure-specialized-caseload");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coos-county-downward-departure-specialized-caseload!./.cache/json/coos-county-downward-departure-specialized-caseload.json
// module id = 864
// module chunks = 231608221292675